import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  details: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "32px"
  },
  title: {
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom: "4px",
    color: colors.lightBlack,
  },
  description: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
  },
  customContentContainer: {
    marginTop: "32px",
    padding: "16px",
    height: "fit-content",
    backgroundColor: colors.brightBlue,
    borderRadius: "8px"
  },
  customContentHeader: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey
  },
  customContentText: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: colors.mediumGrey,
    display: "inline-block",
    maxWidth: "100%",
    verticalAlign: "top",
  },
  
  customContentTextParagraph: {
    marginBottom: "16px"
  },

  customContentTextLastParagraph: {
    display: "ruby"
  },
  
  inlineReadMoreButton: {
    background: "none",
    border: "none",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "18px",
    color: colors.grey,
    cursor: "pointer",
    padding: 0,
    display: "inline",
    marginLeft: "5px",
  },
  manage: {
    padding: "8px 14px 8px 14px",
    width: "fit-content"
  },
  connected: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    padding: "4px 12px 4px 12px",
    borderRadius: "16px",
    backgroundColor: colors.veryLightGreen,
    color: colors.lightgreen,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "500",
  },
  logoDiv: {
    display: "flex",
    alignItems: "center",
  },
  airlineProgramsCard: {
    marginTop: "24px",
    width: "100%",
    display: "flex",
    borderRadius: "20px",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: `0px 1px 3px 0px ${colors.shadowGrey}`,
    border: `1px solid ${colors.lightGrey}`,
    padding: "24px",
    gap: "10px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: 0,
      width: "100%",
    },
    [`@media (min-width: ${breakpoints.xxl}px)`]: {
      width: "100%",
    },
  },
   airlineProgramsContent: {
    display: "flex",
    flexDirection: "column",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
    },
    marginBottom: "30px"
  },
  logoTxt: {
    color: colors.grey,
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    marginBottom: 0,
    marginTop: 0,
    marginLeft: "12px",
  },
  logoTxtDescription: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "24px",
    marginBottom: 0,
    marginTop: 0,
    marginLeft: "12px",
  },
  manageDisabledBtn: {
    pointerEvents: "none",
    color: colors.darkGrey
  },
  buttonsContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    height: "28px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
      alignItems: "flex-end",
      height: "auto"
    },
  },
  cancel: {
    whiteSpace: "nowrap"
  }
}));

export default styles;
